import processApiResponse from "lib/process-api-response"
import sendConventionApiRequest from "lib/send-convention-api-request"

// @ts-ignore PT - #180597146
export default async function getConventionExhibitorWebLinks(current, institution_id) {
  const response = await sendConventionApiRequest({
    current,
    method: "GET",
    url: `v1/convention_providers/${current.provider.id}/convention_exhibitor_web_links?filter[institution_id]=${institution_id}`,
  })

  return await processApiResponse<any[]>(response)
}
